import { withFormik } from 'formik';
import * as Yup from 'yup';

// Yup validation schema for Department
const validationSchema = Yup.object().shape({
    name: Yup.string().required('Department name is required'),
});

// Formik enhancer
export const withFormikValidation = withFormik({
    mapPropsToValues: () => ({
        name: '',
    }),
    validationSchema,
    validateOnMount: true,
    handleSubmit: () => { },
});
